// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  IsAllianzEnv: 'N',
  ENV_ACTIVE_PROFILE: 'cloud',

  API_ROLE_SERVER_URL:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/userrole-service/roles/user',
  //  API_SERVER_URL: "http://localhost:1002",
  CONTEXT_PATH: "/LifeClaimOffice",
  API_SERVER_URL:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/uw/underwriter-service/underwritercases/',
  API_SERVER_URL_FINAL:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/uw/underwriter-service/',
  // API_SERVER_URL:"https://ec2-54-254-255-143.ap-southeast-1.compute.amazonaws.com/dms",
  RESOURCE_SERVER_URL:'https://lifeclaimoffice.dev-1.hub-41.integral.assure.dxc.com/LifeClaimOffice',
  API_CLAIM_OFFICE_SERVER_URL: 'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/claimsOffice/claims/',
  API_CLAIM_REGISTRATION_SERVER_URL: 'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/claimsRegistration/claims/',
  API_QUESTION_URL:"https://api-target2.dxc-assure-policy.com/integral-api-na/omni/service/questionnaire/questionnaire-sets/",
  PDF_PATH:'https://ft2.dxc-assure-policy.com',

  API_UW_URL:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/uw/',
  API_CONFIG_URL: 'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/',
  API_CONFIG_COMMON: 'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/common/configuration/',
  API_UW_REQ_URL:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/life/uwreq/requirementSet/',
  API_LOOK_UP:'https://api.dev-1.hub-41.integral.assure.dxc.com/integral-api/common/configuration/lookup',

  // ON_PREMISE
  ON_PREMISES: 'onPremise',
  SAME_DOMAIN: false,
  // ON_CLOUD
  ON_CLOUD: 'cloud',
  // ON_PREMISES_CAS
  ON_PREMISES_CAS: 'CAS', 
  //Date Format
  DATE_FORMAT: 'DD/MM/YYYY',
  DATE_FORMAT1: 'YYYY-MM-DD',

 // IDP-Configuration
 IDP: {
  issuer: 'https://dev-75842956.okta.com/oauth2/default',
  redirectUri: window.location.origin + '/web',
  clientId: '0oa4s4di29E16yjVV5d7',
  disablePKCE: false,
  responseType: 'code',
},


  //CAS
  OAUTH2_CAS: {
    ClientId: 'qdOE6xIQwIRdFE2rztdPpjEUjPcJnm2e1JJW',
    LoginUrl: 'https://qat-soe.dxc-assure-policy.com/cas/oauth2.0/authorize',
    TokenUrl: 'https://qat-soe.dxc-assure-policy.com/cas/oauth2.0/accessToken',
    CallbackUrl: window.location.origin + '/LifeClaimOffice/claimOffice-web',
    logoutURL:'https://qat-soe.dxc-assure-policy.com/cas/logout',
    landingLogout:'https://qat-soe.dxc-assure-policy.com/ELLandingPortal/user-persona'
  },

 
  // COGNITO-Configuration
  COGNITO: {
      CAS_SERVER_URL: 'https://alb-ext-external.dev-1.hub-41.integral.assure.dxc.com/cas/logout',
      LoginUrl: 'https://asia-dev-1-integralcore.auth.ap-southeast-1.amazoncognito.com/oauth2/authorize',
      TokenUrl: 'https://asia-dev-1-integralcore.auth.ap-southeast-1.amazoncognito.com/oauth2/token',
      UserInfo: 'https://asia-dev-1-integralcore.auth.ap-southeast-1.amazoncognito.com/oauth2/userInfo',
      logoutURL: 'https://asia-dev-1-integralcore.auth.ap-southeast-1.amazoncognito.com/logout',
      userProfileLogout: 'https://elinklandingportal.dev-1.hub-41.integral.assure.dxc.com/ELLandingPortal/user-persona',
      landingPortalUrl: "https://elinklandingportal.dev-1.hub-41.integral.assure.dxc.com/ELLandingPortal",
      SERVER_URL: 'https://asia-dev-1-integralcore.auth.ap-southeast-1.amazoncognito.com/',
      ClientId: '4qrjvcib8nfj9coc1lcjdqkcdr',
      redirectUri: window.location.origin + '/LifeClaimOffice/claimOffice-web',
      scope: 'openid',
      response_type: 'CODE',
      x_api_key: 'oMq1Pop6eQ56NIfUcYcr6aEgKml1kZlC1u6oYPYI',
      landingLogout: "https://elinklandingportal.dev-1.hub-41.integral.assure.dxc.com/ELLandingPortal/EL-LandingPage",
      identity_provider: 'CAS-6soIa'
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
